import { render, staticRenderFns } from "./PageTips.vue?vue&type=template&id=f7a7cb2c&scoped=true&"
import script from "./PageTips.vue?vue&type=script&lang=js&"
export * from "./PageTips.vue?vue&type=script&lang=js&"
import style0 from "./PageTips.vue?vue&type=style&index=0&id=f7a7cb2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a7cb2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VHover,VIcon,VRow,VSkeletonLoader,VTextField})
